import React from "react";

export default function WhatsAppButton({ phone = "917887618891" }) {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(
    "Hi Rise Rift, I'd love to talk about a project."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] blur-xl opacity-40 group-hover:opacity-70 transition" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-emerald-500/30 hover:scale-105 transition-transform">
        <svg viewBox="0 0 32 32" className="w-7 h-7" fill="white" aria-hidden="true">
          <path d="M19.11 17.27c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.3 0 1.36.99 2.68 1.13 2.86.14.18 1.95 2.98 4.73 4.17.66.29 1.17.46 1.57.59.66.21 1.26.18 1.74.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.16.16-1.28-.07-.12-.25-.18-.52-.31zM16.01 4C9.39 4 4 9.39 4 16c0 2.12.56 4.18 1.62 6L4 28l6.18-1.62A12.02 12.02 0 0016.01 28C22.62 28 28 22.62 28 16S22.62 4 16.01 4zm0 22a9.97 9.97 0 01-5.07-1.38l-.36-.21-3.66.96.98-3.58-.24-.37A9.95 9.95 0 116.01 16c0 5.51 4.49 10 9.99 10z"/>
        </svg>
      </span>
    </a>
  );
}
